/**
 * Created by Анжелика on 04.09.2017.
 */
import * as actionTypes from '../constants/actionTypes';
import * as formats from '../constants/formats';
import StalkerApiManager from '../api/StalkerApiLoaderManager';
import {onError} from './index';
import Url from 'url';
import Path from 'path';

let api = StalkerApiManager.getInstance();
let loader = api.getLoader();

export function getChannelLink(channelObject) {
    return dispatch => {
        dispatch({type: actionTypes.GET_CHANNEL_LINK_REQUEST});
        return loader.getChannelLink(channelObject).then(
            data => dispatch({type: actionTypes.GET_CHANNEL_LINK_SUCCESS, url: data, format: _defineChannelLinkFormat(data)}),
            error => dispatch(onError(error, actionTypes.GET_CHANNEL_LINK_FAILED))
        );
    }
}

function _defineChannelLinkFormat(url) {
    let pathName = Url.parse(url).pathname;
    let ext = Path.extname(pathName);
    let findKey = Object.keys(formats).find(key => formats[key] === ext);
    return findKey !== undefined ? formats[findKey] : formats.UNDEFINED_FORMAT;
}


// WEBPACK FOOTER //
// ./src/actions/channelLink.js